import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { plotBackground } from "../../../config/colors";
import "../Tostador.css";

export default function PerfilTermocuplaInferiores() {
  const [termocupla237, setTermocupla237] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [termocupla238, setTermocupla238] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [termocupla239, setTermocupla239] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [termocupla240, setTermocupla240] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 4,
    secuencia: 14,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateTermocupla237(data);
      populateTermocupla238(data);
      populateTermocupla239(data);
      populateTermocupla240(data);

      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateTermocupla237(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrEstado = [];
    // Filter: Temperatura Termocupla 244
    const estado = data.filter(
      (element) => element.Detalle === "Temperatura Termocupla 237"
    );
    // Filter: Estado Termocupla 244
    const temperatura = data.filter(
      (element) => element.Detalle === "Estado Termocupla 237"
    );

    estado.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    temperatura.forEach((element) => {
      arrEstado.push(element.Valor);
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTermocupla237({
      fecha: arrFechas,
      value: arrValues,
      estado: arrEstado,
    });
  }

  function populateTermocupla238(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrEstado = [];
    // Filter: Temperatura Termocupla 244
    const estado = data.filter(
      (element) => element.Detalle === "Temperatura Termocupla 238"
    );
    // Filter: Estado Termocupla 244
    const termo = data.filter(
      (element) => element.Detalle === "Estado Termocupla 238"
    );

    estado.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    termo.forEach((element) => {
      arrEstado.push(element.Valor);
    });

    setTermocupla238({
      fecha: arrFechas,
      value: arrValues,
      estado: arrEstado,
    });
  }

  function populateTermocupla239(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrEstado = [];
    // Filter: Temperatura Termocupla 244
    const estado = data.filter(
      (element) => element.Detalle === "Temperatura Termocupla 239"
    );
    // Filter: Estado Termocupla 244
    const temperatura = data.filter(
      (element) => element.Detalle === "Estado Termocupla 239"
    );

    estado.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    temperatura.forEach((element) => {
      arrEstado.push(element.Valor);
    });

    setTermocupla239({
      fecha: arrFechas,
      value: arrValues,
      estado: arrEstado,
    });
  }

  function populateTermocupla240(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrEstado = [];
    // Filter: Temperatura Termocupla 244
    const estadoTermo244 = data.filter(
      (element) => element.Detalle === "Temperatura Termocupla 240"
    );
    // Filter: Estado Termocupla 244
    const estadoTermocupula244 = data.filter(
      (element) => element.Detalle === "Estado Termocupla 240"
    );

    estadoTermo244.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    estadoTermocupula244.forEach((element) => {
      arrEstado.push(element.Valor);
    });

    setTermocupla240({
      fecha: arrFechas,
      value: arrValues,
      estado: arrEstado,
    });
  }
  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Termocuplas Inferiores"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Termocupla 237 --------------------------------------- */}
            <Chart.Line
              name="Temperatura 237"
              data={termocupla237.value}
              color="blue"
              yAxis={0}
              min={600}
              max={800}
            />

            {/** -------------------------------- Termocupla 238 --------------------------------------- */}
            <Chart.Line
              name="Temperatura 238"
              data={termocupla238.value}
              color="yellow"
              yAxis={0}
              min={600}
              max={800}
            />

            {/** -------------------------------- Termocupla 239 --------------------------------------- */}
            <Chart.Line
              name="Temperatura 239"
              data={termocupla239.value}
              color="green"
              yAxis={0}
              min={600}
              max={800}
            />

            {/** -------------------------------- Termocupla 240 --------------------------------------- */}
            <Chart.Line
              name="Temperatura 240"
              data={termocupla240.value}
              color="red"
              yAxis={0}
              min={600}
              max={800}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={termocupla238.fecha} />

            <Chart.YAxis
              labelSuffix=" °C"
              title="temperatura, °C"
              lineWidth={2}
              lineColor="white"
            />
            <Chart.YAxis
              opposite={true}
              lineWidth={2}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix=" °C" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
